module.exports = __webpack_public_path__ + "static/media/cryptocoins.0265924a.woff";